import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import { openModal } from '../redux/modal';
import Link from '@/components/atoms/Link';
import { performApiRequest, getResultData, invalidateApiDataRequest, getApiDataRequest } from '../redux/apiData';
import { textStyles, colorPalette, shadows } from '../styles/styleGuide';
import { fromBreakpoint } from '../styles/breakpoints';
import WishlistFooter from './shared/designElements/WishlistFooter';
import ImageLoader from './shared/ui/ImageLoader';
import formatPrice from '../services/formatPrice';
import truncateText from '../services/truncateText';
import FavoriteIcon from './shared/icons/Favorite';
import DuplicateIcon from './shared/icons/Copy';
import DeleteIcon from './shared/icons/Delete';
import HouseIconsMap from './shared/designElements/HouseIconsMap';
import PriceTag from './shared/designElements/PriceTag';
import Spinner from './shared/ui/Spinner';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  var wishListId = ownProps.wishList && ownProps.wishList.id;
  return {
    wishListId: wishListId,
    resultWishListFave: getResultData(state.apiData, 'patchWishList', {
      projectSlug: String(projectSlug),
      wishListId: wishListId
    }),
    patchWishListRequest: getApiDataRequest(state.apiData, 'patchWishList', {
      projectSlug: String(projectSlug),
      wishListId: wishListId
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    duplicateWishlist: function duplicateWishlist(wishListId, title, type) {
      dispatch(openModal(colorPalette.lightOrange, {
        type: 'deleteWishList',
        componentProps: {
          title: title,
          wishListId: wishListId,
          projectSlug: String(projectSlug),
          type: type
        }
      }));
    },
    deleteWishlist: function deleteWishlist(wishListId, title, bnr, type) {
      dispatch(openModal(colorPalette.lightOrange, {
        type: 'deleteWishList',
        componentProps: {
          title: title,
          wishListId: wishListId,
          projectSlug: String(projectSlug),
          bnr: bnr,
          ownBNRWishlists: ownProps.ownBNRWishlists,
          ownBNR: Number(ownProps.ownBNR),
          type: type
        }
      }));
    },
    patchWishlist: function patchWishlist(wishListId, favorite, type) {
      dispatch(performApiRequest('patchWishList', {
        projectSlug: String(projectSlug),
        wishListId: wishListId
      }, {
        isFavorite: !favorite
      }));
    },
    forceFetchWishlists: function forceFetchWishlists() {
      dispatch(performApiRequest('getWishLists', {
        projectSlug: String(projectSlug)
      }, undefined, {
        cache: 'disabled'
      }));
    }
  };
};
var WishListCard = /*#__PURE__*/function (_Component) {
  function WishListCard() {
    var _this;
    _classCallCheck(this, WishListCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WishListCard, [].concat(args));
    _defineProperty(_this, "state", {
      selected: undefined
    });
    _defineProperty(_this, "handleEditAction", function (evt, actionObject) {
      var _this$props = _this.props,
        duplicateWishlist = _this$props.duplicateWishlist,
        deleteWishlist = _this$props.deleteWishlist,
        patchWishlist = _this$props.patchWishlist;
      evt.preventDefault();
      evt.stopPropagation();
      switch (actionObject.action) {
        case 'DUPLICATE':
          duplicateWishlist(actionObject.wishListId, String(actionObject.title), actionObject.type);
          break;
        case 'DELETE':
          deleteWishlist(actionObject.wishListId, String(actionObject.title), actionObject.bnr, actionObject.type);
          break;
        case 'FAVORITE':
          patchWishlist(actionObject.wishListId, Boolean(actionObject.favorite), actionObject.type);
          _this.setState({
            selected: actionObject.wishListId
          });
          break;
        default:
          break;
      }
    });
    return _this;
  }
  _inherits(WishListCard, _Component);
  return _createClass(WishListCard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$patchWishL;
      var _this$props2 = this.props,
        patchWishListRequest = _this$props2.patchWishListRequest,
        forceFetchWishlists = _this$props2.forceFetchWishlists;
      var selected = this.state.selected;
      if ((patchWishListRequest && patchWishListRequest.networkStatus === 'success' || patchWishListRequest && patchWishListRequest.networkStatus === 'failed') && selected !== undefined) {
        this.setState({
          selected: undefined
        });
      }

      // force the parent component to refetch the wishlist endpoint without caching, AFTER a change
      var patchRequestDone = ((_prevProps$patchWishL = prevProps.patchWishListRequest) === null || _prevProps$patchWishL === void 0 ? void 0 : _prevProps$patchWishL.networkStatus) === 'loading' && (patchWishListRequest === null || patchWishListRequest === void 0 ? void 0 : patchWishListRequest.networkStatus) !== 'loading';
      if (patchRequestDone) {
        forceFetchWishlists();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        wishList = _this$props3.wishList,
        match = _this$props3.match,
        router = _this$props3.router,
        ownBNR = _this$props3.ownBNR,
        patchWishListRequest = _this$props3.patchWishListRequest;
      var projectSlug = match.params.projectSlug;
      var _wishList$house = wishList.house,
        bnr = _wishList$house.bnr,
        variantCode = _wishList$house.variantCode;
      var selected = this.state.selected;
      var fullBNR = "Bouwnummer ".concat(bnr, " ").concat(variantCode ? '(' + variantCode + ')' : '');
      var categories = [{
        name: 'base',
        title: 'Basis',
        icon: 'houseEmpty',
        hidePriceDelta: true,
        total: wishList.house.price
      }].concat(wishList.totals.categories);
      var notAvailable = wishList.house.status === 'sold' && wishList.house.hasCustomer;
      var isSold = wishList.house.status === 'sold';
      var wishListUrl = "/".concat(projectSlug, "/closed/homestudio/").concat(wishList.id);
      return wishList && wishList.totals ? __jsx(Card, {
        isSelected: this.state.selected === wishList.id,
        "data-e2e-wishlistcard": true,
        "data-e2e-wishlistcard-id": wishList.id,
        "data-e2e-wishlistcard-favorite": wishList.isFavorite,
        "data-id": "components_WishListCard_Card"
      }, selected === wishList.id && (patchWishListRequest === null || patchWishListRequest === void 0 ? void 0 : patchWishListRequest.networkStatus) === 'loading' && __jsx(SpinnerContainer, {
        "data-id": "components_WishListCard_SpinnerContainer"
      }, __jsx(Spinner, {
        monochrome: true,
        color: colorPalette.blue,
        size: "small",
        "data-id": "components_WishListCard_Spinner"
      })), __jsx(LinkElement, {
        href: wishListUrl,
        onClick: function onClick(evt) {
          if (ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable) {
            _this2.handleEditAction(evt, {
              action: 'DELETE',
              wishListId: wishList.id,
              title: wishList.title,
              bnr: wishList.house.bnr,
              type: 'confirmation'
            });
          }
        },
        "data-id": "components_WishListCard_LinkElement"
      }, __jsx(ImageContainer, {
        notAvailable: ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable,
        sold: ownBNR ? isSold && wishList.house.bnr !== ownBNR : isSold,
        "data-id": "components_WishListCard_ImageContainer"
      }, wishList.image && __jsx(ImageLoader, {
        src: wishList.image.image.src,
        width: 380,
        height: 0,
        mode: "bg",
        position: "absolute",
        scaleTransition: true,
        "data-id": "components_WishListCard_ImageLoader"
      }), isSold && __jsx(PriceTagContainer, {
        "data-id": "components_WishListCard_PriceTagContainer"
      }, !wishList.house.hasCustomer && __jsx(PriceTag, {
        isSold: true,
        small: false,
        "data-id": "components_WishListCard_PriceTag"
      }), (ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable) && __jsx("div", {
        "data-id": "components_WishListCard_div"
      }, __jsx("p", {
        "data-id": "components_WishListCard_p"
      }, "Niet meer beschikbaar"), __jsx(DeleteIconButton, {
        onClick: function onClick(evt) {
          return _this2.handleEditAction(evt, {
            action: 'DELETE',
            wishListId: wishList.id,
            title: wishList.title,
            bnr: wishList.house.bnr,
            type: 'delete'
          });
        },
        "data-id": "components_WishListCard_DeleteIconButton"
      }, __jsx(DeleteIcon, {
        "data-id": "components_WishListCard_DeleteIcon"
      }), "Verwijderen"))), !(ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable) && __jsx(InteractContainer, {
        "data-id": "components_WishListCard_InteractContainer"
      }, __jsx(FavoriteIconWrapper, {
        onClick: function onClick(evt) {
          return _this2.handleEditAction(evt, {
            action: 'FAVORITE',
            wishListId: wishList.id,
            favorite: wishList.isFavorite,
            type: 'favo'
          });
        },
        "data-e2e-wishlistcard-actions-favorite": true,
        "data-id": "components_WishListCard_FavoriteIconWrapper"
      }, __jsx(FavoriteIcon, {
        filled: wishList.isFavorite,
        "data-id": "components_WishListCard_FavoriteIcon"
      })), __jsx(DuplicateIconWrapper, {
        onClick: function onClick(evt) {
          return _this2.handleEditAction(evt, {
            action: 'DUPLICATE',
            wishListId: wishList.id,
            title: wishList.title,
            type: 'copy'
          });
        },
        "data-e2e-wishlistcard-actions-duplicate": true,
        "data-id": "components_WishListCard_DuplicateIconWrapper"
      }, __jsx(DuplicateIcon, {
        "data-id": "components_WishListCard_DuplicateIcon"
      })), __jsx(DeleteIconWrapper, {
        onClick: function onClick(evt) {
          return _this2.handleEditAction(evt, {
            action: 'DELETE',
            wishListId: wishList.id,
            title: wishList.title,
            bnr: wishList.house.bnr,
            type: 'delete'
          });
        },
        "data-e2e-wishlistcard-actions-delete": true,
        "data-id": "components_WishListCard_DeleteIconWrapper"
      }, __jsx(DeleteIcon, {
        "data-id": "components_WishListCard_DeleteIcon"
      })))), __jsx(TextContainer, {
        "data-id": "components_WishListCard_TextContainer"
      }, __jsx(Title, {
        notAvailable: ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable,
        "data-id": "components_WishListCard_Title"
      }, truncateText(wishList.title, 50)), __jsx(BuildingSummary, {
        "data-id": "components_WishListCard_BuildingSummary"
      }, __jsx("span", {
        "data-id": "components_WishListCard_span"
      }, fullBNR), wishList.livingSpace, " m\xB2 woonoppervlakte, ", wishList.bedrooms, " slaapkamers"), __jsx(CatList, {
        "data-id": "components_WishListCard_CatList"
      }, categories.map(function (category, index) {
        return __jsx(CatItem, {
          key: index,
          "data-id": "components_WishListCard_CatItem"
        }, __jsx(IconWrapper, {
          "data-id": "components_WishListCard_IconWrapper"
        }, __jsx(HouseIconsMap, {
          icon: category.icon,
          color: (ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable) ? colorPalette.lightBeige : colorPalette.lightOrange,
          "data-id": "components_WishListCard_HouseIconsMap"
        })), category.title, __jsx(PriceContainer, {
          "data-id": "components_WishListCard_PriceContainer"
        }, __jsx(Plus, {
          "data-id": "components_WishListCard_Plus"
        }, category.hidePriceDelta ? '' : category.total > 0 ? '+' : category.total === 0 ? '' : '-'), "\u20AC", __jsx(Price, {
          "data-id": "components_WishListCard_Price"
        }, formatPrice(category.total, {
          showDecimal: true,
          showEuroSign: false
        }))));
      })), __jsx(Footer, {
        "data-id": "components_WishListCard_Footer"
      }, __jsx(WishlistFooter, {
        userWishTotal: wishList.totals.userWishTotal,
        price: wishList.price,
        small: true,
        notAvailable: ownBNR ? notAvailable && wishList.house.bnr !== ownBNR : notAvailable,
        "data-id": "components_WishListCard_WishlistFooter"
      }))))) : null;
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(WishListCard));
var Card = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  transition: opacity 0.25s ease-in-out;\n  opacity: ", ";\n  filter: ", ";\n  position: relative;\n"])), function (props) {
  return props.isSelected ? '0.5' : '1';
}, function (props) {
  return props.notAvailable ? 'grayscale(100%)' : 'grayscale(0%)';
});
var SpinnerContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 9;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var buttonStyling = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 20rem;\n  top: 20rem;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1);\n  background: none;\n  border: none;\n\n  &:hover {\n    transform: scale(1.2);\n  }\n"])));
var FavoriteIconWrapper = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"])), buttonStyling);
var DuplicateIconWrapper = styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  top: 52rem;\n"])), buttonStyling);
var DeleteIconWrapper = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  top: 83rem;\n"])), buttonStyling);
var DeleteIconButton = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 14rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  transition: transform 0.2s ease-in-out;\n  transform: scale(1);\n\n  &:hover {\n    transform: scale(1.2);\n  }\n\n  > svg {\n    margin-right: 10rem;\n  }\n"])));
var PriceTagContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  z-index: 2;\n  ", ";\n  font-weight: bold;\n  color: white;\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    > p {\n      margin-top: 0;\n      text-transform: uppercase;\n    }\n  }\n"])), textStyles.standardText);
var InteractContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 95rem;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  z-index: 2;\n\n  &:before {\n    content: '';\n    opacity: 0.5;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);\n  }\n"])));
var Footer = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  padding-top: 6rem;\n"])));
var Plus = styled.span(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n"])));
var PriceContainer = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding-left: 16rem;\n  width: 100rem;\n  position: absolute;\n  top: 0;\n  right: 0;\n"])));
var IconWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n"])));
var ImageContainer = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n  height: 215rem;\n  width: 100%;\n  position: absolute;\n  overflow: hidden;\n  > div {\n    &:nth-of-type(1) {\n      filter: ", ";\n      > div {\n        filter: ", ";\n      }\n    }\n  }\n"])), function (props) {
  return props.notAvailable ? 'grayscale(100%)' : props.sold ? 'brightness(85%)' : 'contrast(100%)';
}, function (props) {
  return props.notAvailable ? 'brightness(70%)' : 'none';
});
var LinkElement = styled(Link)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  background-color: #ffffff;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  padding-top: 215rem;\n  padding-bottom: 24rem;\n  ", ";\n  transition: box-shadow 0.25s ease;\n\n  &:hover {\n    ", ";\n\n    ", " > div:first-of-type {\n      transform: scale(1.03) translateZ(0);\n    }\n  }\n"])), shadows.boxPrimary, shadows.boxPrimaryHover, ImageContainer);
var TextContainer = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  padding: 0 20rem;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var Title = styled.h3(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 25rem;\n  margin-bottom: 20rem;\n\n  ", ";\n"])), textStyles.title, function (props) {
  return props.notAvailable ? '#696259' : colorPalette.orange;
}, fromBreakpoint.md(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    margin-bottom: -20rem;\n    height: 90rem;\n  "]))));
var BuildingSummary = styled.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  flex-direction: column;\n  color: ", ";\n  margin-top: 0rem;\n  margin-bottom: 24rem;\n\n  > span {\n    font-weight: bold;\n  }\n"])), textStyles.bodyText, colorPalette.textGrey);
var CatList = styled.ul(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  padding: 0;\n  margin-top: 0;\n  list-style: none;\n  margin-bottom: auto;\n"])), textStyles.standardText, colorPalette.textGrey);
var CatItem = styled.li(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-left: 30rem;\n  padding-right: 110rem;\n  margin-bottom: 14rem;\n"])));
var Price = styled.span(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 10rem;\n"])));